<template>
  <div class="post-form-additional">
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">
          <strong>Доступність:</strong>
          <span v-if="public">публічний пост</span>
          <span v-else>приватний пост</span>
        </div>
        <v-card>
          <v-card-text class="grey lighten-5">
              <div v-if="public">
                <p>Зараз цей пост публічний, і доступний будь-кому за адресою:</p>
                <div class="url">{{ url }}</div>
                <v-btn color="red darken-4" @click="makePrivate">Зробити приватним</v-btn>
              </div>
              <div v-else>
                <p>Зараз цей пост приватний, і доступний лише Нашим.</p>
                <p>Для того щоб пост міг побачити будь-хто (а не тільки Наші) його необхідно зробити публічним.</p>
                <v-btn color="green darken-4" @click="makePublic">Зробити публічним</v-btn>
              </div>

          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <div slot="header">
          <strong>Адреса:</strong>
          <span v-if="this.post.autoAlias">автоматично</span>
          <span v-else>вручну</span>
          ({{ this.post.alias }})
        </div>
        <v-card>
          <v-card-text class="grey lighten-5">
            <div class="url">{{ url }}</div>

            <v-switch
              label="формувати адресу автоматично із назви поста"
              v-model="post.autoAlias"
            ></v-switch>

            <div v-if="!post.autoAlias">
              <label>Alias</label>
              <input
                v-model="post.alias"
                placeholder="alias"
                class="alias"
              ></input>
            </div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>

import Vue from 'vue';
import { slugify } from 'transliterations';
import { randomString } from '@/services/random';

export default {
  name: 'PostFormURLSection',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    urlPrefix() {
      return `${location.origin}/p/`;
    },
    urlSuffix() {
      return this.post.publicKey ? `/public/${this.post.publicKey}` : '';
    },
    url() {
      return `${this.urlPrefix}${this.post.alias}${this.urlSuffix}`;
    },
    public() {
      return !!this.post.publicKey;
    },
  },
  watch: {
    post(value) {
      this.$emit('update:post', value);
    },
    'post.title': 'checkAlias',
    'post.autoAlias': 'checkAlias',
  },
  mounted() {
    if (!this.post.autoAlias && this.post.autoAlias !== false) {
      Vue.set(this.post, 'autoAlias', true);
    }

    this.checkAlias();
  },
  methods: {
    checkAlias() {
      if (this.post.autoAlias) {
        Vue.set(this.post, 'alias', slugify(this.post.title));
      }
    },
    makePublic() {
      Vue.set(this.post, 'publicKey', randomString(32));
    },
    makePrivate() {
      Vue.set(this.post, 'publicKey', null);
    },
  },
};

</script>

<style scoped>

.url {
  border: dashed 1px #ddd;
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  background: #f9f9f9;
  font-size: 14px;
  word-break: break-all;
}

</style>



// WEBPACK FOOTER //
// src/components/PostFormAdditional.vue